var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22244(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22244",
    "data-name": "Group 22244",
    transform: "translate(-547 -2045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22241",
    "data-name": "Group 22241",
    transform: "translate(252 -781.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5653",
    "data-name": "Rectangle 5653",
    width: 85,
    height: 85,
    rx: 15,
    transform: "translate(295 2826.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4213462_communication_global_internet_network_web_icon",
    "data-name": "4213462_communication_global_internet_network_web_icon",
    transform: "translate(562.572 2060.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27646",
    "data-name": "Path 27646",
    d: "M26.928,51.855A24.928,24.928,0,1,0,2,26.928,24.949,24.949,0,0,0,26.928,51.855Zm-19.3-15,10.132-.08a36.086,36.086,0,0,0,5.589,11.539A21.742,21.742,0,0,1,7.629,36.859ZM20.334,20.093H32.959a34.109,34.109,0,0,1,.08,13.389l-12.705.08A33.043,33.043,0,0,1,20.334,20.093Zm6.312,27.3a32.272,32.272,0,0,1-5.508-10.614l11.057-.08A33.969,33.969,0,0,1,26.646,47.393Zm3.216,1.045a35.452,35.452,0,0,0,5.669-11.78l10.815-.08A21.764,21.764,0,0,1,29.863,48.438Zm18.776-21.51a22.423,22.423,0,0,1-.965,6.433l-11.378.08a36.341,36.341,0,0,0-.08-13.348h11.3A21.371,21.371,0,0,1,48.639,26.928ZM46.146,16.876H35.451A36.971,36.971,0,0,0,29.863,5.418,21.618,21.618,0,0,1,46.146,16.876Zm-14.032,0H21.178A33.219,33.219,0,0,1,26.646,6.463,33.219,33.219,0,0,1,32.114,16.876ZM23.349,5.538a35.725,35.725,0,0,0-5.508,11.338H7.709A21.634,21.634,0,0,1,23.349,5.538ZM17.077,20.093a36.993,36.993,0,0,0-.04,13.469L6.3,33.642a20.8,20.8,0,0,1-1.086-6.714,21.371,21.371,0,0,1,1.126-6.835Z",
    fill: "#6d4eec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22244);
export default __webpack_public_path__ + "static/media/Group 22244.07be939d94b36572b01e360e97c87af0.svg";
export { ForwardRef as ReactComponent };